export default __webpack_public_path__ + "static/media/property_53.71ca7324.png";